import Swiper from "swiper/bundle";
import "swiper/css/bundle";

const gallerySlider = new Swiper(".gallery-slider", {
  slidesPerView: 1,
  spaceBetween: 20,
  breakpoints: {
    768: {
      spaceBetween: 20,
      slidesPerView: 2,
    },
    992: {
      spaceBetween: 20,
      slidesPerView: 5,
    },
  },

  navigation: {
    prevEl: "#gallery .prev",
    nextEl: "#gallery .next",
  },
  loop: true,
  on: {
    slidePrevTransitionStart() {
      if (window.innerWidth < 992) return;
      const wrapp = document.querySelectorAll(
        ".gallery-slider .swiper-wrapper"
      );
      const slide = document.querySelectorAll(
        ".gallery-slider .swiper-slide img"
      );
      slide.forEach((item) => {
        item.style.transitionDelay = "0ms";
      });
      wrapp.forEach((item) => {
        item.style.transition = "2000ms";
      });
    },

    slideNextTransitionStart() {
      if (window.innerWidth < 992) return;
      const wrapp = document.querySelectorAll(
        ".gallery-slider .swiper-wrapper"
      );
      const slide = document.querySelectorAll(
        ".gallery-slider .swiper-slide img"
      );
      slide.forEach((item) => {
        item.style.transitionDelay = "200ms";
      });
      wrapp.forEach((item) => {
        item.style.transition = "500ms";
      });
    },
  },
});
